import "@/Common/Components/IconControls/AttachDocumentLink.css";

import img_icon_myle_pictogrammes_documents_31 from "@/Globals/_images/icons/documents/MYLE-Pictogrammes-Documents-31.png";

interface IAttachDocumentLinkProps {
    onClick?: () => void;
}

function AttachDocumentLink(props: IAttachDocumentLinkProps): JSX.Element {
    return (
        <div
            className="flex-container attach-document-link"
            data-cy="attach-document-link"
        >
            <a className="pointer" onClick={() => props.onClick()}>
                <img
                    className="marginright5 img-document-link"
                    src={img_icon_myle_pictogrammes_documents_31}
                />
                {cacheStore.GetString("AttachADocumentLabel")}
            </a>
        </div>
    );
}

export { AttachDocumentLink };
